import React,{useRef,useCallback} from 'react';
import ChecklistDetail from "./checklistdetail.jsx";

 export default function   ChecklistPaginationHelper (props) {
  let commentsTotalLength=props.checklistsArray.length;
    const observer=useRef();
    const lastBookElementRef=useCallback(node =>{
      if(!props.hasMore) return;
      if(observer.current) observer.current.disconnect();
      observer.current=new IntersectionObserver(entries=>{
           if(entries[0].isIntersecting  && props.hasMore ){
             props.getChecklists();
             observer.current.disconnect();
            
           }
      })
      if(node)observer.current.observe(node);
   },[props.hasMore]);

   

   let commentList=null;
   if(commentsTotalLength>0){
    commentList= props.checklistsArray.map((checklist, index) => {
      if(checklist.id instanceof Object){
        return;
      }         
      return  <ChecklistDetail
      key={checklist.id + checklist.activity_id}
      checklist={checklist}
      searchText={props.searchText}
      selectedOption={props.selectedOption}
      idOfElement={props.idOfElement}
      checklistItemId={props.checklistItemId}
      users={props.users}
      isSuperAdmin={props.isSuperAdmin}
      createChecklistItemAction={props.createChecklistItemAction}
      activityDetails={props.activityDetails}
      is_archived={props.is_archived}
      updateChecklistItemAction={props.updateChecklistItemAction}
      updateChecklistAction={props.updateChecklistAction}
      is_priority={props.is_priority}
      index={index}
      onRearrangeClick={props.onRearrangeClick}
      checklistOpenStatus={
        props.clickedChecklistId === checklist.id ? true : false
      }
      updateFetch={props.updateFetch}
      onMoveOfItemToAnotherList={props.onMoveOfItemToAnotherList}
      setChecklist={props.setChecklist}
      checklistsArray={props.checklistsArray}
    ></ChecklistDetail>
  
})
commentList.push(<div ref={lastBookElementRef}  key={new Date()}></div>);     
   }
  
   return (
       <>
           {
             commentList
           }

       </>
   );
  
}


